import { useCallback, useState } from 'react'

import { useUnit } from 'effector-react'

import { Button } from '@/components/ui/button'
import { CalendarDatePicker } from '@/components/ui/calendar/calendar-date-picker'
import { Dialog } from '@/components/ui/dialog'
import {
  getChatSummaryReportFx,
  summarizeFx,
} from '@/models/chattingUI/chatSummary.ts'

import type { DialogProps } from '../types'

export const SummarizeChatDialog = ({ isOpen, onClose }: DialogProps) => {
  const [startDate, setStartDate] = useState<Date | undefined>(new Date())
  const isSummarizing = useUnit(summarizeFx.pending)

  const handleDateChange = useCallback((date?: Date) => {
    if (date) {
      setStartDate(date)
    }
  }, [])
  const handleClickSummarize = useCallback(async () => {
    onClose()
    await getChatSummaryReportFx(startDate!)
  }, [onClose, startDate])

  return (
    <Dialog
      show={isOpen}
      onClose={isSummarizing ? null : onClose}
      bigDialog
      panelClassName="lg:max-w-[533px]"
    >
      <div className="space-y-6">
        <Dialog.Header>
          <Dialog.Title>Summarize Chat</Dialog.Title>
          <Dialog.Description className="mx-auto block max-w-[407px] text-center">
            You can summarize the chat from a specific date to the present.
          </Dialog.Description>
        </Dialog.Header>
        <div className="space-y-1.5">
          <label className="text-sm font-medium leading-6">From date</label>
          <CalendarDatePicker
            date={startDate}
            onChange={handleDateChange}
            toDate={new Date()}
            position="top"
          />
        </div>
        <Dialog.ClosableFooter
          onClose={onClose}
          disabled={isSummarizing}
        >
          <Button
            onClick={handleClickSummarize}
            isLoading={isSummarizing}
          >
            Summarize
          </Button>
        </Dialog.ClosableFooter>
      </div>
    </Dialog>
  )
}
